import { Link } from 'react-router-dom';
import LegalPageLayout, { LegalSection, LegalList, LegalNote } from './LegalPageLayout';

export default function KvkkPage() {
  return (
    <LegalPageLayout title="KVKK Aydınlatma Metni" updated="Mayıs 2025">
      <div className="legal-intro">
        <p>
          Bu KVKK Aydınlatma Metni, NoteSwapp adlı mobil uygulama ve internet sitesi kapsamında kişisel verilerinizin
          hangi amaçlarla işlendiğini, kimlerle paylaşılabileceğini, hangi yöntemlerle toplandığını, hangi hukuki
          sebeplere dayanılarak işlendiğini ve 6698 sayılı Kişisel Verilerin Korunması Kanunu (&quot;KVKK&quot;)
          kapsamındaki haklarınızı açıklamak amacıyla hazırlanmıştır.
        </p>
        <p>
          NoteSwapp, TÜBİTAK 2209-B projesi kapsamında Begüm Sezer ve Zeynep Reyyan Kaleli tarafından geliştirilen,
          öğrencilerin ders notlarını paylaşmasını, aramasını ve not değişimi yapmasını amaçlayan akademik bir not
          paylaşım platformudur.
        </p>
      </div>

      <LegalSection title="1. Veri Sorumlusu">
        <p>
          6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel verileriniz aşağıda belirtilen veri
          sorumluları tarafından işlenmektedir:
        </p>
        <p><strong>Veri sorumluları:</strong> Begüm Sezer ve Zeynep Reyyan Kaleli (TÜBİTAK 2209-B Proje Yürütücüleri)</p>
        <p><strong>Proje:</strong> NoteSwapp</p>
        <p><strong>Proje türü:</strong> TÜBİTAK 2209-B Öğrenci Projesi</p>
        <p><strong>İletişim e-postası:</strong> <a href="mailto:noteswapp@gmail.com">noteswapp@gmail.com</a></p>
        <p><strong>Web sitesi / uygulama:</strong> NoteSwapp</p>
        <p>Kişisel verilerinizle ilgili taleplerinizi noteswapp@gmail.com adresi üzerinden bize iletebilirsiniz.</p>
      </LegalSection>

      <LegalSection title="2. İşlenen Kişisel Veriler">
        <p>NoteSwapp hizmetlerinden yararlanmanız sırasında aşağıdaki kişisel verileriniz işlenebilir:</p>
        <LegalList items={[
          'Kimlik ve profil bilgileri: Ad, soyad, kullanıcı adı, profil fotoğrafı, üniversite, fakülte, bölüm, sınıf, dönem ve kullanıcı profilinde yer alan bilgiler.',
          'İletişim bilgileri: E-posta adresi ve bildirim tercihleri.',
          'Hesap bilgileri: Kullanıcı ID bilgisi, hesap oluşturma tarihi, giriş yöntemi, hesap durumu, oturum bilgileri ve güvenlik kayıtları.',
          'Akademik içerik bilgileri: Yüklenen ders notları, dosya adları, ders adı, dönem, bölüm, fakülte, açıklama, etiketler, not kategorisi, notun yüklenme tarihi, onay durumu ve sistemsel değerlendirme bilgileri. (Not içeriklerinde kullanıcının kendisi veya üçüncü kişiler tarafından bırakılmış kişisel veriler yer alıyorsa, bu veriler NoteSwapp tarafından bilerek işlenmemekte olup, sisteme yüklenmesi tamamen kullanıcının sorumluluğundadır.)',
          'Kullanım bilgileri: Arama, filtreleme, görüntüleme, indirme, favorilere ekleme, not yükleme, not takası, bildirim hareketleri ve uygulama içi işlem kayıtları.',
          'Teknik veriler: IP adresi, cihaz bilgisi, işletim sistemi, uygulama sürümü, tarayıcı bilgisi, hata kayıtları, log kayıtları ve güvenlik amaçlı teknik kayıtlar.',
          'Destek ve iletişim kayıtları: Kullanıcı tarafından iletilen destek talepleri, geri bildirimler, şikayetler ve e-posta yazışmaları.',
          'Yapay zeka analiz bilgileri: Yüklenen dokümanların ders notu olup olmadığı, okunabilirliği, kategori uyumu, kalite durumu, spam veya uygunsuz içerik kontrolü gibi yapay zeka destekli (Gemini API ve benzeri altyapılar) analiz sonuçları.',
        ]} />
        <LegalNote>
          <p><strong>Önemli not:</strong> NoteSwapp, kullanıcılardan özel nitelikli kişisel veri talep etmez. Kullanıcılar; kimlik numarası, öğrenci numarası, telefon numarası, adres, imza, sağlık bilgisi, özel hayat bilgisi, dini inanç, siyasi görüş veya üçüncü kişilere ait kişisel verileri içeren dosyaları sisteme yüklememelidir.</p>
        </LegalNote>
      </LegalSection>

      <LegalSection title="3. Kişisel Verilerin İşlenme Amaçları">
        <p>Kişisel verileriniz aşağıdaki amaçlarla işlenebilir:</p>
        <LegalList items={[
          'Kullanıcı hesabının oluşturulması ve yönetilmesi ile uygulamaya giriş yapabilmesi',
          'NoteSwapp hizmetlerinin sunulması; not yükleme, arama, görüntüleme ve not değişimi süreçlerinin yürütülmesi',
          'Üniversite, fakülte, bölüm, dönem ve ders bilgilerine göre içeriklerin düzenlenmesi',
          'Yüklenen notların ders notu olup olmadığının kontrol edilmesi, platform güvenliğinin ve içerik kalitesinin artırılması',
          'Yapay zeka destekli sistemler vasıtasıyla kalite, güvenlik, uygunsuz, boş, spam veya alakasız içeriklerin denetlenmesi ve tespiti',
          'Kullanıcı deneyiminin iyileştirilmesi, teknik hataların tespiti, giderilmesi ve uygulama güvenliğinin sağlanması',
          'Kötüye kullanım, sahte hesap ve yetkisiz erişimlerin önlenmesi',
          'Kullanıcı destek taleplerinin yanıtlanması',
          'Yasal yükümlülüklerin yerine getirilmesi ve yetkili kurum/kuruluşlardan gelen taleplerin karşılanması',
          'Hizmetlerin geliştirilmesi, akademik proje raporlamaları ve istatistiksel analizlerin yapılması',
        ]} />
      </LegalSection>

      <LegalSection title="4. Kişisel Verilerin Toplanma Yöntemi">
        <p>Kişisel verileriniz elektronik ortamda aşağıdaki yöntemlerle toplanabilir:</p>
        <LegalList items={[
          'Mobil uygulama veya web sitesi üzerinden hesap oluşturmanız ve profil bilgilerinizi doldurmanız',
          'Ders notu veya belge yüklemeniz, uygulama içinde arama, filtreleme, görüntüleme, indirme veya takas işlemleri yapmanız',
          'Destek veya iletişim kanalları üzerinden bizimle iletişime geçmeniz',
          'Supabase, Firebase ve benzeri teknik altyapılar üzerinden oluşan sistem kayıtları, log kayıtları, cihaz bilgileri ve güvenlik kayıtları',
          'Gemini API ve benzeri yapay zeka sistemleri üzerinden yapılan içerik analizleri',
        ]} />
      </LegalSection>

      <LegalSection title="5. Kişisel Verilerin İşlenmesinin Hukuki Sebepleri">
        <p>Kişisel verileriniz, KVKK&apos;nın 5. maddesinde yer alan aşağıdaki hukuki sebeplere dayanılarak işlenebilir:</p>
        <p><strong>Sözleşmenin kurulması veya ifası için gerekli olması:</strong> Hesap oluşturma, giriş yapma, not yükleme, not arama ve NoteSwapp hizmetlerinden yararlanma işlemleri için gerekli veriler bu kapsamda işlenir.</p>
        <p><strong>Hukuki yükümlülüğün yerine getirilmesi:</strong> Yetkili kamu kurum ve kuruluşlarından gelen taleplerin karşılanması ve yasal yükümlülüklerin yerine getirilmesi amacıyla veriler işlenebilir.</p>
        <p><strong>Bir hakkın tesisi, kullanılması veya korunması:</strong> Uyuşmazlık, şikayet, kötüye kullanım, güvenlik incelemesi veya platform kurallarının ihlali durumlarında kişisel veriler işlenebilir.</p>
        <p><strong>Meşru menfaat:</strong> Platform güvenliğinin sağlanması, kötüye kullanımın ve spam içeriklerin yapay zeka entegrasyonları vasıtasıyla önlenmesi, hizmet kalitesinin artırılması, teknik hataların giderilmesi ve sistemsel analizlerin yapılması amacıyla veriler işlenebilir.</p>
        <p><strong>Açık rıza:</strong> Uygulama altyapısının işletilmesi için zorunlu olan yurt dışı aktarımları ve zorunlu olmayan duyuru/bilgilendirme bildirimleri için açık rızanız alınır. Detaylar için <Link to="/acik-riza">Açık Rıza Metni</Link>&apos;ni inceleyebilirsiniz.</p>
      </LegalSection>

      <LegalSection title="6. Kişisel Verilerin Aktarılması">
        <p>Kişisel verileriniz, yukarıda belirtilen amaçlarla sınırlı olmak üzere aşağıdaki kişi ve kuruluşlarla paylaşılabilir:</p>
        <LegalList items={[
          'Supabase ve benzeri veri tabanı, kimlik doğrulama ve depolama hizmet sağlayıcıları',
          'Firebase ve benzeri bildirim, analiz, kimlik doğrulama ve teknik altyapı sağlayıcıları',
          'Gemini API ve benzeri yapay zeka ve içerik analiz hizmet sağlayıcıları',
          'Bulut altyapı, sunucu, hata izleme, güvenlik ve performans analiz hizmet sağlayıcıları',
          'E-posta ve iletişim hizmet sağlayıcıları',
          'Hukuki ve teknik danışmanlar',
          'Yetkili kamu kurum ve kuruluşları, mahkemeler, savcılıklar ve yasal olarak bilgi talep etmeye yetkili makamlar',
        ]} />
        <p>NoteSwapp, kişisel verilerinizi üçüncü kişilere satmaz.</p>
      </LegalSection>

      <LegalSection title="7. Yurt Dışına Veri Aktarımı">
        <p>
          NoteSwapp&apos;ın kesintisiz ve güvenli çalışması için Supabase, Firebase, Gemini API ve benzeri teknik altyapı
          sağlayıcıları kullanılmaktadır. Bu hizmet sağlayıcıların sunucuları veya alt hizmet sağlayıcıları yurt dışında
          bulunabilmektedir.
        </p>
        <p>
          Bu nedenle kişisel verileriniz ve yüklediğiniz not içerikleri; hizmetin sunulması, verilerin saklanması, kimlik
          doğrulama, bildirim, güvenlik, teknik altyapı yönetimi ve yapay zeka destekli not kontrolü amaçlarıyla yurt
          dışına aktarılmaktadır. Yurt dışına aktarım süreçleri, KVKK&apos;nın güncel hükümleri uyarınca{' '}
          <strong>&quot;Açık Rıza&quot;</strong> hukuki sebebine dayanarak veya ilgili küresel sağlayıcıların sunduğu{' '}
          <strong>Standart Sözleşmeler (SCC)</strong> doğrultusunda mevzuata uygun şekilde yürütülür.
        </p>
      </LegalSection>

      <LegalSection title="8. Yapay Zeka Destekli Not Kontrolü">
        <p>
          NoteSwapp, yüklenen içeriklerin gerçekten ders notu veya akademik çalışma materyali olup olmadığını kontrol etmek,
          platform güvenliğini sağlamak ve spam/uygunsuz içerikleri filtrelemek amacıyla veri sorumlusunun meşru menfaatleri
          kapsamında yapay zeka destekli sistemler (Gemini API vb.) kullanır.
        </p>
        <p>
          Bu analizler esnasında yapay zeka sistemlerine doğrudan profil verileriniz (isim, e-posta vb.) aktarılmamakta,
          yalnızca yüklenen doküman içeriği taranmaktadır. Yapay zeka sistemi, kullanıcılar hakkında akademik başarı,
          kişilik, yetenek veya benzeri hassas çıkarımlar yapmak amacıyla kullanılmaz.
        </p>
      </LegalSection>

      <LegalSection title="9. Kullanıcı Tarafından Yüklenen Dosyalar">
        <p>Kullanıcılar NoteSwapp&apos;a ders notu, özet, çalışma dokümanı veya benzeri akademik içerikler yükleyebilir.</p>
        <p>Kullanıcılar aşağıdaki içerikleri yüklememelidir:</p>
        <LegalList items={[
          'Kimlik numarası, öğrenci numarası veya resmi belge görüntüsü',
          'Telefon numarası, adres, e-posta veya imza',
          'Sağlık bilgisi, özel hayat bilgisi veya özel nitelikli kişisel veri',
          'Üçüncü kişilere ait kişisel veriler, izinsiz telifli içerikler',
          'Sınav kurallarını veya okul kurallarını ihlal eden, hakaret, nefret söylemi, reklam veya spam içeren dokümanlar',
        ]} />
        <p>
          Bu tür içeriklerin tespit edilmesi halinde ilgili not kaldırılabilir, erişimi sınırlandırılabilir veya hesap
          hakkında işlem yapılabilir.
        </p>
      </LegalSection>

      <LegalSection title="10. Kişisel Verilerin Saklama Süresi">
        <p>
          Kişisel verileriniz, işleme amaçları için gerekli olan süre boyunca saklanır. Hesabınız aktif olduğu sürece hesap
          ve profil bilgileriniz saklanır. Hesabınızın silinmesini talep etmeniz halinde kişisel verileriniz, yasal saklama
          yükümlülükleri ve hukuki gereklilikler saklı kalmak üzere silinir, yok edilir veya anonim hale getirilir. Log
          kayıtları, güvenlik kayıtları ve uyuşmazlıkla ilgili kayıtlar kanuni zamanaşımı süreleri uyarınca makul sürelerle
          saklanabilir.
        </p>
      </LegalSection>

      <LegalSection title="11. Kişisel Verilerin Güvenliği">
        <p>
          NoteSwapp, kişisel verilerin hukuka aykırı işlenmesini, yetkisiz erişilmesini ve güvenli şekilde saklanmasını
          önlemek için idari ve teknik imkanları dahilinde gerekli tedbirleri (yetkilendirme kontrolü, güvenli kimlik
          doğrulama, log kayıtlarının tutulması ve güvenli bulut altyapılarının kullanılması) almaya çalışır.
        </p>
      </LegalSection>

      <LegalSection title="12. İlgili Kişinin Hakları">
        <p>
          KVKK&apos;nın 11. maddesi kapsamında kişisel verilerinizle ilgili olarak; verilerinizin işlenip işlenmediğini
          öğrenme, işlenmişse bilgi talep etme, işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme, yurt
          içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme, eksik veya yanlış işlenen verilerin düzeltilmesini
          isteme, verilerin silinmesini veya yok edilmesini isteme, otomatik sistemler sonucunda aleyhinize bir sonucun
          ortaya çıkmasına itiraz etme ve zarara uğramanız halinde zararın giderilmesini talep etme haklarına sahipsiniz.
        </p>
      </LegalSection>

      <LegalSection title="13. Başvuru Yöntemi">
        <p>
          KVKK kapsamındaki taleplerinizi, sistemlerimizde kayıtlı e-posta adresiniz üzerinden{' '}
          <a href="mailto:noteswapp@gmail.com">noteswapp@gmail.com</a> adresine yazılı olarak iletebilirsiniz.
        </p>
        <p>
          Başvurunuzda ad, soyad, NoteSwapp hesabınızla ilişkili e-posta adresi, talebinizin konusu ve açıklaması yer
          almalıdır. Talepleriniz mevzuat kapsamında değerlendirilerek en geç 30 gün içinde yanıtlanacaktır.
        </p>
      </LegalSection>

      <LegalSection title="14. Metin Değişiklikleri">
        <p>
          NoteSwapp, bu KVKK Aydınlatma Metni&apos;nde uygulamanın geliştirilmesi, kullanılan hizmet sağlayıcıların
          değişmesi veya mevzuat değişiklikleri nedeniyle güncelleme yapabilir. Güncel metin uygulama içinde veya web
          sitesinde yayınlanır. İlgili diğer metinler:{' '}
          <Link to="/gizlilik-politikasi">Gizlilik Politikası</Link>, <Link to="/acik-riza">Açık Rıza Metni</Link>.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
